<h2 mat-dialog-title>Crop Image</h2>
<mat-dialog-content>
  <image-cropper
    (cropperReady)="cropperReady()"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded()"
    (loadImageFailed)="loadImageFailed()"
    [aspectRatio]="aspectRatio"
    [format]="format"
    [imageChangedEvent]="imageChangedEvent"
    [imageFile]="imageFile"
    [maintainAspectRatio]="true"
  ></image-cropper>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="cancel()" mat-button>Cancel</button>
  <button (click)="save()" color="primary" mat-raised-button>Save</button>
</mat-dialog-actions>
